/* eslint-disable no-param-reassign */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, TabPane, TabContent,
  NavLink, NavItem, Nav, Button, Label, InputGroup,
} from 'reactstrap';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import {
  Field, FormikConsumer, ErrorMessage,
} from 'formik';

import * as url from '../../helpers/url_helper';
import { get } from '../../helpers/api_helper';

function SupplierItemFieldset(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const { remove, entityId, index } = props;

  const [data, setData] = useState({
    supplier_sku: '-',
    linked_item: {
      sku: '-',
    },
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchData = async (id) => {
      try {
        const item = await get(`${url.GET_SUPPLIER_ITEM}/${id}`);

        setData(item);
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    };

    setLoading(true);
    fetchData(entityId);
  }, [entityId]);

  return (
    <FormikConsumer>
      {({
        touched, errors, values, setFieldValue,
      }) => (
        <Row>
          <Col xl="9">
            <Row>
              <Col md="7">
                <Label for={`items[${index}]_supplier_item`}>
                  {props.t('Supplier Item')}
                </Label>
                <InputGroup size="sm">
                  <input
                    className="form-control"
                    id={`items[${index}]_supplier_item`}
                    readOnly
                    value={loading ? props.t('Loading...') : `${data.supplier_sku}${data.linked_item !== null ? ` / ${data.linked_item.manufacturer} ${data.linked_item.part_number}` : ''}`}
                  />
                  <Button color="danger" className="btn btn-dark" onClick={() => { remove(); }}>
                    <span className="mdi mdi-close-thick" />
                  </Button>
                </InputGroup>
              </Col>
              <Col md="5">
                <Label for={`items[${index}]_qty`}>
                  {props.t('Expected Qty')}
                </Label>
                <InputGroup size="sm">
                  <span className="input-group-text">
                    <span className="mdi mdi-window-close" />
                  </span>
                  <Field name={`items[${index}].qty`} id={`items[${index}]_qty`} min="1" step="1" type="number" className="form-control" />
                </InputGroup>
                <ErrorMessage
                  name={`items[${index}].qty`}
                  component="div"
                  className="text-danger"
                />
              </Col>
            </Row>
            <Row className="mt-2">
              <Col md="7">
                {data.notes !== '' && (
                  <p className="text-muted">
                    <span className="text-warning mdi mdi-comment-alert" />
                    &nbsp;
                    {data.notes}
                  </p>
                )}
              </Col>
              <Col md="5">
                <Label for={`items[${index}]_price`}>
                  {props.t('Cost')}
                </Label>
                <InputGroup size="sm">
                  <span className="input-group-text">
                    <span className="bx bx-dollar" />
                  </span>
                  <Field name={`items[${index}].price`} id={`items[${index}]_price`} step=".01" min="0" type="number" className="form-control" />
                </InputGroup>
                <ErrorMessage
                  name={`items[${index}].price`}
                  component="div"
                  className="text-danger"
                />
              </Col>
            </Row>
          </Col>

          {data.linked_item !== null && (
            <Col xl="3">
              <img src={`/api/items/thumbnail/${data.linked_item.id}`} className="img-fluid" alt={props.t('Linked item thumbnail')} />
            </Col>
          )}
        </Row>
      )}
    </FormikConsumer>
  );
}

SupplierItemFieldset.defaultProps = {
  t: (x) => (x),
  remove: () => {},
};

SupplierItemFieldset.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  t: PropTypes.any,
  remove: PropTypes.func,
  entityId: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
};

export default connect(() => ({

}), {})(withTranslation()(SupplierItemFieldset));
